module.exports = __webpack_public_path__ + "kibervarnost/media/za-profilno-sliko-je-lahko-kdorkoli.960d035b.mp4";